<template>
  <div class="Bar-wrap" ref="chart">
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "Bar",
  props: {
    info: {
      type: Object
    },
    isDisposeData: { //是否在组件内部处理data 、y轴单位、tooltip的单位
      type: Boolean,
      default: false
    },
    confirmUnit: { //需要对组件给的默认单位进行再加工的话传它 需要return 一个字符串
      type: Function
    },
    beforeTooltip: {
      type: Function
    }
  },
  components: {

  },
  data() {
    return {
      myChart: null,
      hideToolTip: false
    };
  },
  computed: {

  },
  watch: {
    info: {
      handler(val){
        this.myChart && this.myChart.dispose()
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    /* 
      支持单柱、堆叠柱状、及单住和堆叠混合，折线图也可使用该组件
      this.info = {
        xAxis: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        data: [
          { 
            stack: '111',
            color: 'deeppink',  // 封装时添加的属性，会添加至itemStyle配置中
            barWidth: 40,
            name: '系列一',
            data: [32, 43, 34, 54, 65, 23, 32],
            ...{},  // 传入任何官方支持的配置
          },
          { 
            stack: '111',
            color: 'deepskyblue',   // 封装时添加的属性，会添加至itemStyle配置中
            barWidth: 40,
            name: '系列二',
            data: [32, 43, 34, 54, 65, 23, 32],
            ...{},  // 传入任何官方支持的配置
          },
          { 
            color: 'yellow',   // 封装时添加的属性，会添加至itemStyle配置中
            barWidth: 20,
            name: '系列三',
            data: [32, 43, 34, 54, 65, 23, 32],
            ...{},  // 传入任何官方支持的配置
          },
        ],
        custom: {},
      }
    
    */
    
  },
  mounted() {
    // this.myChart && this.myChart.on('datazoom', this.chartScroll)
    // this.myChart && this.myChart.on('datazoom', () => {
    //   console.log('败退啦 :>> ');
    // })
  },
  // beforeDestroy() {
  //   this.myChart && this.myChart.off('datazoom', this.chartScroll)
  // },
  methods: {
    initChart(){
      let {
        data = [],
        custom = {},
        xAxis = [],
      } = this._.cloneDeep(this.info || {})
      let series = data.map(x => {
        let obj = {
          type: x.type || 'bar',
          stack: x.stack || '',
          itemStyle: {
            color: x.color || '',
            borderRadius: 4        
          },
          barWidth: x.barWidth || 25,
          data: [],
          ...x
        }
        return obj
      })

      if(!(custom?.yAxis instanceof Array)){
        custom.yAxis = [custom?.yAxis || {}]
      }
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          right: '3%',
          selectedMode:false
        },
        grid: {
          right: 0,
          bottom: '8%',
          left: 0,
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xAxis,
          axisLabel: {
            color: '#767A7E',
            fontSize: 14,
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: '#F5F7F9'
            }
          }
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            color: '#999999',
            fontSize: 14
          },
          splitLine: {
            lineStyle: {
              color: '#F5F7F9',
              type: 'dashed'
            }
          },
        }],
        series,
        color: ["#4091FD"]
      };

      let unitText = ""
      if(this.isDisposeData && series.length){
        
        option.yAxis = this._.merge(option.yAxis, custom?.yAxis || {})
        // 遍历序列 处理y轴的单位
        series.forEach((item,idx)=>{
          let curData = []
          item.data.forEach(x =>{
            if(typeof(x) === 'number' || typeof(x) === 'string'){
              curData.push({value:Number(x)})
            }else{
              curData.push({x,value:Number(x.value)})
            }
          })
          series[idx].data = curData

          let maxValue = this._.maxBy(item.data,function(o) { 
            return Math.abs(o.value)
          })
          let unitByValue = Math.abs(maxValue?.value || 0)

          if(unitByValue < 10000){

          }else if(10000 <= unitByValue && unitByValue < 100000000){
            unitText = "万"
          }else{
            unitText = "亿"
          }

          let yAxisIdx = item.yAxisIndex || 0
          option.yAxis[yAxisIdx].name = this?.confirmUnit?.(unitText) || unitText
        })

        // 处理data数据
        let newSeries = this._.cloneDeep(series).map((x,idx)=>{
          let cur = []
          let curUnit = custom?.yAxis?.[x.yAxisIndex]?.name || option.yAxis?.[x.yAxisIndex]?.name || option.yAxis?.[0]?.name
          x.data.forEach(y=>{
            if(Object.prototype.toString.call(y) === '[object Object]'){
              let {value} = this.fmt(y.value ,{isObject: true ,fixedUnit: curUnit })
              cur.push({...y,value,unit:curUnit})
            }else{
              let {value} = this.fmt(y ,{isObject: true ,fixedUnit: curUnit})
              cur.push({value,unit:curUnit})
            }
          })
          x.data = cur
          return x
        })
        option.series = newSeries

        // 处理tooltip的单位
        option.tooltip.formatter = (params) => {
          let title = `${params[0].name}<br/>`
          let content = ''
          params.forEach(x=>{
              let curUnit =  x.data.unit
              content+= `${x.marker} ${x.seriesName} <span style="float: right;margin-left:20px">${x.value}${curUnit}</span><br/>`
          })
          // marker: <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#ff770f;"></span>
          return this?.beforeTooltip?.({
            params, 
            title,
            content,
            setOther: ({color, name, text}) => {
              return `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span> ${name} <span style="float: right;margin-left:20px">${text}</span><br/>`
            }
          }) || (title + content)
        }

      }

      option = this._.merge(option, custom)
      // !(xAxis.length === 1 && xAxis[0] === "" && !option.yAxis?.[0]?.data.length)  这个是给横向的柱形图判断的（如排行榜）
      if(xAxis.length && !(xAxis.length === 1 && xAxis[0] === "" && !option.yAxis?.[0]?.data.length)){ //有时候切换成排行榜的柱形图 会给xAxis设置为xAxis: [""]
        option.title = {
          show: false,
          top:0,
          left:0
        }
        option = this._.merge(option, custom)
      }else{
        option.title = {
          show: true,
          text: '暂无数据',
          top: 'middle',
          left: 'center'
        }
        option.series.forEach(x => {
          x.data = []
        })
      }
      if(!this.$refs.chart){return}
      this.myChart = echarts.init(this.$refs.chart)
      // console.log('option :>> ', option);
      this.myChart.setOption(option)

      if(option.xAxis.triggerEvent){
        let _this = this
        this.myChart.on("click",function(params){
          let allData = _this.myChart.getOption()?.series.map(x => {
            let cur = x.data.filter(item => {
              return item?.x?.axisLabel === params.name
            })
            if(cur.length) {
              cur[0].name = params.name
            }
            return cur[0]
          })
          _this.$emit('xAxisClick',params, allData)
        })
        this.myChart.on("dblclick",function(params){
          if(params.targetType === "axisLabel"){  
            // 添加横坐标对应的系列原始数据供外部处理
            let opt = _this.myChart.getOption()?.series?.[0]?.data?.[params.dataIndex] || {}
            params.data = opt
          }
          _this.$emit('chartDblclick',params)
        })
      }

      // this.myChart && this.myChart.on('datazoom', this.chartScroll)
      
    },
    chartScroll({ batch = [{}] }) {
      // 滚动的时候隐藏tooltip
      console.log('图表被拖动 ！！！！！！！！！！！！:>> ',);
      this.hideToolTip = true
      this.myChart.setOption({
        tooltip: {
          show: !this.hideToolTip,
        },
      })
    }
  }
};
</script>

<style scoped lang="less">
.Bar-wrap{
  width: 100%;
  height: 100%;
}
</style>